var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7996 10.5312C22.0517 10.7578 22.0746 11.1211 21.8187 11.4141C21.6315 11.6719 21.2418 11.6953 20.9896 11.4336L19.5608 10.1445V17.875C19.5608 19.6016 18.1931 21 16.5044 21H5.50148C3.8136 21 2.44511 19.6016 2.44511 17.875V10.1445L1.01587 11.4336C0.762573 11.6953 0.376286 11.6719 0.152941 11.4141C-0.0704412 11.1211 -0.0462959 10.7578 0.206848 10.5312L10.598 1.15633C10.831 0.947891 11.1749 0.947891 11.4079 1.15633L21.7996 10.5312ZM5.50148 19.75H7.94657V13.5C7.94657 12.8086 8.4929 12.25 9.16912 12.25H12.8368C13.513 12.25 14.0593 12.8086 14.0593 13.5V19.75H16.5044C17.5168 19.75 18.3382 18.9102 18.3382 17.875V9.07422L11.0029 2.45859L3.66765 9.07422V17.875C3.66765 18.9102 4.48905 19.75 5.50148 19.75ZM9.16912 19.75H12.8368V13.5H9.16912V19.75Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7efe58fce2d690c9388d499b4428ad2d.svg";
export { ForwardRef as ReactComponent };